/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Questionnaire_Editor_File_UploadInputs */

const en_admin_questionnaire_editor_file_upload = /** @type {(inputs: Admin_Questionnaire_Editor_File_UploadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`File upload`)
};

/** @type {(inputs: Admin_Questionnaire_Editor_File_UploadInputs) => LocalizedString} */
const de_admin_questionnaire_editor_file_upload = en_admin_questionnaire_editor_file_upload;

/** @type {(inputs: Admin_Questionnaire_Editor_File_UploadInputs) => LocalizedString} */
const es_admin_questionnaire_editor_file_upload = en_admin_questionnaire_editor_file_upload;

/** @type {(inputs: Admin_Questionnaire_Editor_File_UploadInputs) => LocalizedString} */
const fr_admin_questionnaire_editor_file_upload = en_admin_questionnaire_editor_file_upload;

/** @type {(inputs: Admin_Questionnaire_Editor_File_UploadInputs) => LocalizedString} */
const it_admin_questionnaire_editor_file_upload = en_admin_questionnaire_editor_file_upload;

/** @type {(inputs: Admin_Questionnaire_Editor_File_UploadInputs) => LocalizedString} */
const pt_br2_admin_questionnaire_editor_file_upload = en_admin_questionnaire_editor_file_upload;

/** @type {(inputs: Admin_Questionnaire_Editor_File_UploadInputs) => LocalizedString} */
const pl_admin_questionnaire_editor_file_upload = en_admin_questionnaire_editor_file_upload;

/** @type {(inputs: Admin_Questionnaire_Editor_File_UploadInputs) => LocalizedString} */
const hu_admin_questionnaire_editor_file_upload = en_admin_questionnaire_editor_file_upload;

/** @type {(inputs: Admin_Questionnaire_Editor_File_UploadInputs) => LocalizedString} */
const ro_admin_questionnaire_editor_file_upload = en_admin_questionnaire_editor_file_upload;

/**
* | output |
* | --- |
* | "File upload" |
*
* @param {Admin_Questionnaire_Editor_File_UploadInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_questionnaire_editor_file_upload = /** @type {((inputs?: Admin_Questionnaire_Editor_File_UploadInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Questionnaire_Editor_File_UploadInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_questionnaire_editor_file_upload(inputs)
	if (locale === "de") return de_admin_questionnaire_editor_file_upload(inputs)
	if (locale === "es") return es_admin_questionnaire_editor_file_upload(inputs)
	if (locale === "fr") return fr_admin_questionnaire_editor_file_upload(inputs)
	if (locale === "it") return it_admin_questionnaire_editor_file_upload(inputs)
	if (locale === "pt-BR") return pt_br2_admin_questionnaire_editor_file_upload(inputs)
	if (locale === "pl") return pl_admin_questionnaire_editor_file_upload(inputs)
	if (locale === "hu") return hu_admin_questionnaire_editor_file_upload(inputs)
	return ro_admin_questionnaire_editor_file_upload(inputs)
});
export { admin_questionnaire_editor_file_upload as "admin.questionnaire_editor.file_upload" }